<script lang="ts">
	export let inlineMode = false;

</script>

<div class:inlineMode>
	<svg viewBox="0 0 100 100">
		<circle cx="50" cy="50" r="48" />
	</svg>
</div>

<style lang="scss">
	div {
		width: 100%;
		height: 100%;

		&.inlineMode {
			width: 1rem;
			height: auto;
		}
	}
	svg {
		animation: loading-spin 3s infinite;
	}

	circle {
		fill: none;
		stroke: rgb(101, 145, 250);
		stroke-width: 3;
		stroke-dasharray: 157, 157;
		stroke-dashoffset: 0;
		animation: loading-circle-ani 1s infinite;
	}

	@keyframes loading-spin {
		100% {
			transform: rotate(360deg);
		}
	}
	@keyframes loading-circle-ani {
		0% {
			stroke-dashoffset: 157;
		}
		75% {
			stroke-dashoffset: -147;
		}
		100% {
			stroke-dashoffset: -157;
		}
	}

</style>
